module.exports = __webpack_public_path__ + "static/media/team-3@2x.3e6112ce.jpg";